import type { BaasMeldingPayload } from '@lvflanders/bar';

import { BarMeldingType } from './bar-melding-type.enum';

export function toBarMelding(melding: BaasMeldingPayload): BarMelding {
    const meldingTypeMapping = {
        20: BarMeldingType.Opgelost,
        40: BarMeldingType.Informatief,
        60: BarMeldingType.Belangrijk,
        80: BarMeldingType.Onbeschikbaar,
        90: BarMeldingType.Banner
    } satisfies Record<Extract<BaasMeldingPayload, { baas: false }>['meldingType'], BarMeldingType>;

    if (melding.baas === true) {
        //BaaS melding
        const readField = (field: string) => melding.fields?.find((f) => f.name === field)?.content;
        return {
            id: melding.meldingId,
            startDate: melding.validFrom,
            endDate: melding.validUntil,
            meldingType: melding.meldingType,
            location: melding.urlPattern,
            content: readField('TEKST'),
            title: readField('TITEL'),
            zone: melding.zone
        } as unknown as BarMelding;
    }
    //BAR melding
    else {
        return {
            id: melding.id,
            startDate: melding.startDatum,
            endDate: melding.eindDatum,
            meldingType: meldingTypeMapping[melding.meldingType],
            location: melding.locatie,
            content: melding.tekst,
            zone: melding.zone
        } as unknown as BarMelding;
    }
}

// TODO [STEPET] with next major use type instead of class and remove convert
export class BarMelding {
    id: number;
    startDate?: Date;
    endDate?: Date;
    meldingType: BarMeldingType;
    location: string;
    content: string;
    title: string;
    zone: string;

    /** @deprecated Use toBarMelding instead. This will be removed with next major. */
    convert(m: any): this {
        const melding = toBarMelding(m);
        Object.assign(this, melding);
        return this;
    }
}
